import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, message, DatePicker } from 'antd'

import storageUtils from '../../utils/storageUtils'
import { req_add_eca_english_activity } from '../../api'

import moment from 'moment';
import 'moment/locale/zh-tw';
import locale from 'antd/lib/locale/zh_TW';
const { RangePicker } = DatePicker

class EnglishActivityAdd extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        item: {
            //activityUid, 
            board: 'ENGLISH',
            activityTypeCode: 'OTHER',
            recordCreateAccount: '',
            recordCreateAccountName: '',
            activityTitle: '',
            activityContent: '',
            registrationStartDate: '1999-01-01 00:00:00.000',
            registrationEndDate: '1999-01-01 00:00:00.000',
            activityStartDate: new Date(),
            activityEndDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
            signEnableTime: '1999-01-01 00:00:00.000',
            signDisableTime: '1999-01-01 00:00:00.000',
            sponsorUnit: '語文訓練中心',
            sponsorOfficer: '',
            cosponsorUnit: '',
            cosponsorOfficer: '',
            contactPerson: '',
            contactPhone: '',
            quotaLimit: 999,
            activityScope: 'INSIDE',
            participantsType: '學生',
            location: '校內',
            cost: 0,
            hasMeal: 'N',
            mealDescription: '',
            hasLearnCertificate: 'N',
            learnTimeHours: 0,
            needLeave: 'N',
            hasTeam: 'N',
            canTogether: 'N',
            showParticipants: 'N',
            isAbroad: 'N',
            recordStatus: 'UNCHECK',
            limitFileSize: '3M',
            limitFileType: '無限制格式',
            isShowBoard: 'N',
            activitySource: 'LOCAL',
            setPoints: 1,
            setGrade: 0
        }
    }

    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {

    }

    // 遠端數據處理 //////////////////////////////////////////////


    api_add_item = async (item) => {
        const result = await req_add_eca_english_activity(item, storageUtils.getUser().token)
        if (result.status === "success") {
            message.success(result.message)
            
        } else {
            message.error(result.message)
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    handleChange(event) {
        const { item } = this.state
        //console.log(event)
        Object.keys(item).forEach(propertyName => {
            if (event.target.id === propertyName && event.target.value !== null) {
                item[propertyName] = event.target.value.trim()
            }
        });
        this.setState({ item })
    }

    handleDateTimeRangeChange = (dates, dateStrings) => {
        const { item } = this.state
        item.activityStartDate = dateStrings[0]
        item.activityEndDate = dateStrings[1]
        this.setState({ item })
        //console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    }

    handleSubmit(event) {
        event.preventDefault()
        const row = this.state.item
        const errors = []

        if (!row.activityTypeCode.trim()) {
            errors.push('主旨未填')
        }

        if (errors.length === 0) {
            // console.log(row)
            row.recordCreateAccount = storageUtils.getUser().userCode
            row.recordCreateAccountName = storageUtils.getUser().userName
            row.sponsorOfficer = storageUtils.getUser().userName

            row.registrationStartDate = row.activityStartDate
            row.registrationEndDate = row.activityEndDate

            row.signEnableTime = row.activityStartDate
            row.signDisableTime = row.activityEndDate

            this.api_add_item(row)
        } else {
            let info = errors.join(',')
            message.error(info);
        }
    }


    /////////////////////////////////////////////////////////////     
    render() {
        const { activityTypeCode, activityTitle, activityStartDate, activityEndDate, setPoints } = this.state.item
        return (
            <Card>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label><span className="text-danger">*</span>主旨</label>
                                <input type="text" className="form-control text-primary" style={{ backgroundColor: 'LightYellow' }} name="activityTitle" id="activityTitle" defaultValue={activityTitle} aria-describedby="mobileHelp" placeholder="請輸入主旨" onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label><span className="text-danger ">*</span>自學分類</label>
                                <select name="activityTypeCode" id="activityTypeCode" className="custom-select mb-3 text-success" style={{ backgroundColor: 'LightCyan' }}  defaultValue={activityTypeCode} key={activityTypeCode} onChange={this.handleChange} >
                                    <option value="OTHER">請選擇</option>
                                    <option value="TALK">Let's Talk Cafe</option>
                                    <option value="BASE">講座</option>
                                    <option value="GAME">比賽</option>
                                    <option value="STUDY">潛能班</option>
                                    <option value="TEST">自學測驗</option>
                                    <option value="SPECIAL">特別班</option>
                                    <option value="LICENCE">證照抵免</option>
                                    <option value="STRATEGY">多益閱讀</option>
                                    <option value="LISTEN">多益聽力</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label><span className="text-danger">*</span>基本點數</label>
                                <input type="number" className="form-control text-primary" name="setPoints" id="setPoints" defaultValue={setPoints} key={setPoints} min='0.5' max='20.0' step='0.5' style={{ backgroundColor: 'LightYellow' }} aria-describedby="mobileHelp" placeholder="請輸入點數" onChange={this.handleChange} />
                            </div>
                        </div>
                        <div className="col-lg">
                            <div className="form-group">
                                <label><span className="text-danger">*</span>起訖時間</label>
                                <div>
                                    <RangePicker
                                        locale={locale}
                                        defaultValue={[moment(activityStartDate, "YYYY/MM/DD HH:mm:ss"), moment(activityEndDate, "YYYY/MM/DD HH:mm:ss")]}
                                        ranges={{
                                            '今天': [moment(), moment()],
                                            '整個月份': [moment().startOf('month'), moment().endOf('month')],
                                        }}
                                        style={{ backgroundColor: 'LightCyan' }}
                                        showTime
                                        format="YYYY/MM/DD HH:mm:ss"
                                        onChange={this.handleDateTimeRangeChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <input type="submit" value="增加" className="btn btn-warning btn-sm" />
                            </div>
                        </div>
                    </div>
                </form>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(EnglishActivityAdd)